<div 
  [style.scroll-padding-top.px]="scrollPaddingTop()"
  class="timeline-container tw-snap-y tw-snap-mandatory tw-overscroll-y-contain tw-scroll-smooth tw-overflow-y-auto tw-flex tw-flex-col tw-w-full tw-h-full tw-px-4 lg:tw-px-6 tw-gap-4 tw-font-inter tw-items-center tw-relative">
  <app-events-timeline-header
    #archivedEventsTimelineHeader
    class="tw-snap-start tw-snap-always tw-block"
    mode="archived"
    [isFloating]="true"
    [archivedTitle]="headerTitle()"
    [searchTerm]="searchControl.value"
    searchPlaceholder="Search archived events"
    (criteriaChanged)="onArchivedCriteriaChanged($event)"
    (onDisplayFloatingHeader)="onDisplayFloatingHeader($event)"
  ></app-events-timeline-header>

  @if (isInitialLoading() || loadingInitialPersonas()) {
    <app-events-timeline-skeleton-card class="tw-w-full tw-block"></app-events-timeline-skeleton-card>
  } @else if (!events().length) {
    <app-events-timeline-empty-state
      [mode]="getEmptyStateMode()"
      heading="You don’t have any archived events."
      filterLabel="archived"
      [showCreateButton]="false"
    ></app-events-timeline-empty-state>
  } @else {
    <div
      class="tw-bg-transparent tw-w-full tw-flex-1 tw-flex tw-flex-col tw-gap-0"
    >
      @for (event of events(); track event.id) {
        <app-event-wrapper
          class="tw-snap-start tw-snap-always tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full"
          [model]="getEventWrapperModel(event, $last)"
          (modalStateChanged)="onModalStateChanged($event)"
          (restoreConfirmed)="onRestoreConfirmed($event)"
          (deletePermanentlySucceeded)="onDeletePermanentlySucceeded($event)"
        ></app-event-wrapper>
      }
      <div #archivedLoadMoreTrigger class="tw-h-4 tw-w-full"></div>
    </div>
  }

  @if (isPaginating()) {
    <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
      <div class="tw-w-6 tw-h-6 tw-border-2 tw-border-blue-600 tw-border-t-transparent tw-rounded-full tw-animate-spin"></div>
    </div>
  }
</div>
